import "./App.css";

import { ThemeProvider } from "@mui/material/styles";
import { Provider } from "react-redux";
import { store } from "./features/store/configureStore";
import theme from "./Constants/Theme";
import { ReactNotifications } from "react-notifications-component";
import "react-notifications-component/dist/theme.css";
import "bootstrap/dist/js/bootstrap.bundle.min";
import "bootstrap/dist/css/bootstrap.min.css";
import { LovModal, SibaProvider, ModalNotification, ModalConfirmation, MultiLovModal } from "@siba/components";
import "../../node_modules/react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import AppRouter from "./Routes";

/**
 * Application start point
 */
export default function App(): JSX.Element {
    return (
        //Provider wraps the App and the whole application has access to Redux
        <>
            <ReactNotifications />
            <Provider store={store}>
                <SibaProvider>
                    <ThemeProvider theme={theme}>
                        <LovModal />
                        <ModalNotification />
                        <MultiLovModal />
                        <ModalConfirmation />

                        <AppRouter />
                    </ThemeProvider>
                </SibaProvider>
            </Provider>
        </>
    );
}
